import {InvoicePaymentSummaryApiDto} from "../../api/model/rest";
import {option, Option} from "ts-option";
import moment = require("moment");

export default class InvoicePaymentSummary {

	constructor(public readonly id: string,
		public readonly invoiceId: string,
		public readonly invoiceNo: Option<string>,
		public readonly invoiceDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly due: number,
		public readonly total: number,
		public readonly paymentAmount: number,
		public readonly customerDisplayName: string,
		public readonly canUndoReconciliation: boolean) {}

	static fromJson(json: InvoicePaymentSummaryApiDto): InvoicePaymentSummary {
		return new InvoicePaymentSummary(json.id, json.invoiceId, option(json.invoiceNo), moment(json.invoiceDate),
			json.referenceNumber, json.due, json.total, json.paymentAmount, json.customerDisplayName, json.canUndoReconciliation);
	}
}
